var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition-group',{attrs:{"tag":"div","appear":"","name":"bounce-in","css":false},on:{"before-appear":_vm.beforeEnter,"appear":_vm.appear,"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }